/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DtoTravelCreateDraft } from '../../models/dto-travel-create-draft';
import { TravelDraft } from '../../models/travel-draft';

export interface TravelControllerSaveDraft$Params {
  id: number;
      body: DtoTravelCreateDraft
}

export function travelControllerSaveDraft(http: HttpClient, rootUrl: string, params: TravelControllerSaveDraft$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelDraft;
}>> {
  const rb = new RequestBuilder(rootUrl, travelControllerSaveDraft.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TravelDraft;
      }>;
    })
  );
}

travelControllerSaveDraft.PATH = '/travel/draft/{id}';
